const liquidityOracleAbi = [
	{
		"inputs": [
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			},
			{
				"internalType": "string",
				"name": "name",
				"type": "string"
			}
		],
		"name": "addRouter",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "authorize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IERC20[]",
				"name": "tokens",
				"type": "address[]"
			}
		],
		"name": "setBackingTokens",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract ISmartRewards",
				"name": "_smartRewards",
				"type": "address"
			}
		],
		"name": "setSmartRewards",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			},
			{
				"internalType": "contract ISmartRewards",
				"name": "_smartRewards",
				"type": "address"
			},
			{
				"internalType": "contract IActivePools",
				"name": "_activePools",
				"type": "address"
			}
		],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": false,
				"internalType": "address",
				"name": "owner",
				"type": "address"
			}
		],
		"name": "OwnershipTransferred",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "contract IDEXRouter[]",
				"name": "routers",
				"type": "address[]"
			},
			{
				"internalType": "string[]",
				"name": "names",
				"type": "string[]"
			}
		],
		"name": "setRouters",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address payable",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "transferOwnership",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "unauthorize",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"name": "_backingTokens",
		"outputs": [
			{
				"internalType": "contract IERC20",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"name": "_routers",
		"outputs": [
			{
				"internalType": "contract IDEXRouter",
				"name": "",
				"type": "address"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "contract IDEXRouter",
				"name": "",
				"type": "address"
			}
		],
		"name": "dexName",
		"outputs": [
			{
				"internalType": "string",
				"name": "",
				"type": "string"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "getAllSmartRewardsBnbValues",
		"outputs": [
			{
				"internalType": "contract IERC20[]",
				"name": "tokens",
				"type": "address[]"
			},
			{
				"internalType": "uint256[]",
				"name": "bnbValues",
				"type": "uint256[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [],
		"name": "getAllSmartRewardsUsdValues",
		"outputs": [
			{
				"internalType": "contract IERC20[]",
				"name": "tokens",
				"type": "address[]"
			},
			{
				"internalType": "uint256[]",
				"name": "usdValues",
				"type": "uint256[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "tokenAddress",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "bnbAmount",
				"type": "uint256"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			}
		],
		"name": "getBNBValueToken",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_tokenAddress",
				"type": "address"
			},
			{
				"internalType": "bool",
				"name": "useSmartRewardsTokens",
				"type": "bool"
			},
			{
				"internalType": "bool",
				"name": "useSmartRewardsPreferredDex",
				"type": "bool"
			}
		],
		"name": "getLiquidityPairsInfo",
		"outputs": [
			{
				"components": [
					{
						"internalType": "contract IERC20",
						"name": "token",
						"type": "address"
					},
					{
						"internalType": "contract IERC20",
						"name": "backingToken",
						"type": "address"
					},
					{
						"internalType": "contract IDEXRouter",
						"name": "router",
						"type": "address"
					},
					{
						"internalType": "contract IDEXPair",
						"name": "pairAddress",
						"type": "address"
					},
					{
						"internalType": "uint256",
						"name": "tokenPriceInBNB",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "tokenBalanceInLiquidityPair",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "backingTokenPriceInBNB",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "backingTokenBalanceInLiquidityPair",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalLPTokens",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "lpTokenValueInBnb",
						"type": "uint256"
					},
					{
						"internalType": "string",
						"name": "dexName",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "backingTokenName",
						"type": "string"
					},
					{
						"internalType": "uint256",
						"name": "backingTokenDecimals",
						"type": "uint256"
					}
				],
				"internalType": "struct LiquidityOracleLibrary.LiquidityPairs[]",
				"name": "pairsInfo",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	// {
	// 	"inputs": [
	// 		{
	// 			"internalType": "address",
	// 			"name": "_tokenAddress",
	// 			"type": "address"
	// 		},
	// 		{
	// 			"internalType": "contract IERC20[]",
	// 			"name": "backingTokens",
	// 			"type": "address[]"
	// 		},
	// 		{
	// 			"internalType": "bool",
	// 			"name": "useSmartRewardsPreferredDex",
	// 			"type": "bool"
	// 		}
	// 	],
	// 	"name": "getLiquidityPairsInfo",
	// 	"outputs": [
	// 		{
	// 			"components": [
	// 				{
	// 					"internalType": "contract IERC20",
	// 					"name": "token",
	// 					"type": "address"
	// 				},
	// 				{
	// 					"internalType": "contract IERC20",
	// 					"name": "backingToken",
	// 					"type": "address"
	// 				},
	// 				{
	// 					"internalType": "contract IDEXRouter",
	// 					"name": "router",
	// 					"type": "address"
	// 				},
	// 				{
	// 					"internalType": "contract IDEXPair",
	// 					"name": "pairAddress",
	// 					"type": "address"
	// 				},
	// 				{
	// 					"internalType": "uint256",
	// 					"name": "tokenPriceInBNB",
	// 					"type": "uint256"
	// 				},
	// 				{
	// 					"internalType": "uint256",
	// 					"name": "tokenBalanceInLiquidityPair",
	// 					"type": "uint256"
	// 				},
	// 				{
	// 					"internalType": "uint256",
	// 					"name": "backingTokenPriceInBNB",
	// 					"type": "uint256"
	// 				},
	// 				{
	// 					"internalType": "uint256",
	// 					"name": "backingTokenBalanceInLiquidityPair",
	// 					"type": "uint256"
	// 				},
	// 				{
	// 					"internalType": "uint256",
	// 					"name": "totalLPTokens",
	// 					"type": "uint256"
	// 				},
	// 				{
	// 					"internalType": "uint256",
	// 					"name": "lpTokenValueInBnb",
	// 					"type": "uint256"
	// 				},
	// 				{
	// 					"internalType": "string",
	// 					"name": "dexName",
	// 					"type": "string"
	// 				},
	// 				{
	// 					"internalType": "string",
	// 					"name": "backingTokenName",
	// 					"type": "string"
	// 				},
	// 				{
	// 					"internalType": "uint256",
	// 					"name": "backingTokenDecimals",
	// 					"type": "uint256"
	// 				}
	// 			],
	// 			"internalType": "struct LiquidityOracleLibrary.LiquidityPairs[]",
	// 			"name": "pairsInfo",
	// 			"type": "tuple[]"
	// 		}
	// 	],
	// 	"stateMutability": "view",
	// 	"type": "function"
	// },
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "_tokenAddress",
				"type": "address"
			}
		],
		"name": "getLiquidityPairsInfo",
		"outputs": [
			{
				"components": [
					{
						"internalType": "contract IERC20",
						"name": "token",
						"type": "address"
					},
					{
						"internalType": "contract IERC20",
						"name": "backingToken",
						"type": "address"
					},
					{
						"internalType": "contract IDEXRouter",
						"name": "router",
						"type": "address"
					},
					{
						"internalType": "contract IDEXPair",
						"name": "pairAddress",
						"type": "address"
					},
					{
						"internalType": "uint256",
						"name": "tokenPriceInBNB",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "tokenBalanceInLiquidityPair",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "backingTokenPriceInBNB",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "backingTokenBalanceInLiquidityPair",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "totalLPTokens",
						"type": "uint256"
					},
					{
						"internalType": "uint256",
						"name": "lpTokenValueInBnb",
						"type": "uint256"
					},
					{
						"internalType": "string",
						"name": "dexName",
						"type": "string"
					},
					{
						"internalType": "string",
						"name": "backingTokenName",
						"type": "string"
					},
					{
						"internalType": "uint256",
						"name": "backingTokenDecimals",
						"type": "uint256"
					}
				],
				"internalType": "struct LiquidityOracleLibrary.LiquidityPairs[]",
				"name": "pairsInfo",
				"type": "tuple[]"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "tokenAddress",
				"type": "address"
			}
		],
		"name": "getTokenBnbValue",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "bnbValue",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "tokenAddress",
				"type": "address"
			},
			{
				"internalType": "contract IERC20[]",
				"name": "tokens",
				"type": "address[]"
			},
			{
				"internalType": "contract IDEXRouter[]",
				"name": "routers",
				"type": "address[]"
			},
			{
				"internalType": "bool",
				"name": "useSmartRewardsPreferredDex",
				"type": "bool"
			}
		],
		"name": "getTokenBnbValue",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "tokenAddress",
				"type": "address"
			},
			{
				"internalType": "bool",
				"name": "useSmartRewards",
				"type": "bool"
			},
			{
				"internalType": "bool",
				"name": "useSmartRewardsPreferredDex",
				"type": "bool"
			}
		],
		"name": "getTokenBnbValueSmartRewards",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "bnbValue",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "tokenAddress",
				"type": "address"
			},
			{
				"internalType": "contract IERC20",
				"name": "token",
				"type": "address"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			}
		],
		"name": "getTokenPairBalance",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "tokenAddress",
				"type": "address"
			},
			{
				"internalType": "address",
				"name": "underlying",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenAmount",
				"type": "uint256"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "underlyingRouter",
				"type": "address"
			}
		],
		"name": "getTokenValueAgainstUnderlyingTokenBNB",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "bnbValue",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "tokenAddress",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenAmount",
				"type": "uint256"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			}
		],
		"name": "getTokenValueBNB",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "tokenAddress",
				"type": "address"
			},
			{
				"internalType": "uint256",
				"name": "tokenAmount",
				"type": "uint256"
			},
			{
				"internalType": "contract IDEXRouter",
				"name": "router",
				"type": "address"
			}
		],
		"name": "getTokenValueUSD",
		"outputs": [
			{
				"internalType": "uint256",
				"name": "",
				"type": "uint256"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "adr",
				"type": "address"
			}
		],
		"name": "isAuthorized",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "account",
				"type": "address"
			}
		],
		"name": "isOwner",
		"outputs": [
			{
				"internalType": "bool",
				"name": "",
				"type": "bool"
			}
		],
		"stateMutability": "view",
		"type": "function"
	}
];

export default liquidityOracleAbi;









